import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Objects, Types} from "components";
import {Button} from "reactstrap";
import {Tooltip} from "@material-ui/core";
import Notes from "@material-ui/icons/Notes";

/**
 *  @property {Outstanding_Invoices_Object} state
 *  @property {object} model
 *  @property {Outstanding_Invoices_Properties} model.properties
 *  @property {Outstanding_Invoices_Is} model.is
 *  @property {Outstanding_Invoices_Has} model.has
 *  @property {Call_Types_Object} call_types
 *  @property {Regions_Object} regions
 *  @property {Users_Object} users
 */
export default class OutstandingInvoice extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Outstanding_Invoices._name);
		this.state = {
			...this.state,
			showFreshdesk: false
		}
	}

	form = () => {
		/**
		 * @param {Outstanding_Invoices_Properties} data
		 */
		let {properties} = this.model;

		/**
		 * @type {Outstanding_Invoices_Object}
		 */
		let object = this.state;

		let {loading} = this.state;

		return (
			<div className={'form-group'}>
				<div className={'row'}>
					<div className={'col-12'}>
						<fieldset>

							<div className={"form-group"}>
								<div className="d-flex align-items-start" style={{gap: "10px"}}>
									<div style={{flexGrow: 1}}>
										<Framework.Elements.Select
											shouldLoad={this.state.loaded}
											property={properties.ticket}
											value={object.ticket}
											object={object.tickets}
											error={object.ticket_error}
											model={Types.Tickets._name}
											update={this.handleSelectPropertyUpdate}
											text={"invoice_text"}
											label={"Associated Ticket (Customer | Engineer | Freshticket)"}
											nullable={true}
										/>
									</div>

									<Button color="info" onClick={() => {
										this.setState({showFreshdesk: true})
									}}>
										Add Freshticket
									</Button>
								</div>
							</div>

							{this.state.showFreshdesk && (
								<div className={"form-group"} style={{marginTop: "10px"}}>
									<Framework.Elements.TextField
										value={object.fresh_ticket}
										error={object.fresh_ticket_error}
										property={properties.fresh_ticket}
										update={this.handleTextFieldPropertyUpdate}
										label={"Manually Attached Freshticket"}
									/>
								</div>
							)}


							{/* ===== Notes ===== */}
							<div className={"form-group"}>
								<Framework.Elements.TextField
									value={object.notes.replace(/\\n\\n/g, "\n\n")}
									error={object.notes_error}
									property={properties.notes}
									update={this.handleTextFieldPropertyUpdate}
									label={"Notes"}
									multiline={6}
								/>
							</div>

							{/* ===== Reason ===== */}
							<div className={"form-group"}>
								<Framework.Elements.TextField
									value={object.reason}
									error={object.reason_error}
									property={properties.reason}
									update={this.handleTextFieldPropertyUpdate}
									label={"Reason"}
								/>
							</div>

							<div className={"form-group"}>
								<Framework.Elements.TextField
									value={object.client}
									error={object.client_error}
									property={properties.client}
									update={this.handleTextFieldPropertyUpdate}
									label={"Client"}
								/>
							</div>

							<div className="row">
								<div className="col-md-6">
									<div className={"form-group"}>
										<Framework.Elements.TextField
											value={object.total_invoice}
											error={object.total_invoice_error}
											property={properties.total_invoice}
											update={this.handleTextFieldPropertyUpdate}
											label={"Total Invoice"}
										/>
									</div>
								</div>

								<div className="col-md-6">
									<div className={"form-group"}>
										<Framework.Elements.TextField
											value={object.square_url}
											error={object.square_url_error}
											property={properties.square_url}
											update={this.handleTextFieldPropertyUpdate}
											label={"Square URL"}
										/>
									</div>
								</div>
							</div>

							{/* ===== Status Flags ===== */}
							<div className="row">
								<div className="col-md-6">
									<Framework.Elements.Checkbox
										value={object.valid}
										property={properties.valid}
										error={object.valid_error}
										update={() => this.setState({valid: !object.valid})}
										label={'Valid'}
									/>
								</div>

								<div className="col-md-6">
									<Framework.Elements.Checkbox
										value={object.paid}
										property={properties.paid}
										error={object.paid_error}
										update={() => this.setState({paid: !object.paid})}
										label={'Paid'}
									/>
								</div>
							</div>

							<div className="row">
								<div className="col-md-6">
									<Framework.Elements.Checkbox
										value={object.first_email}
										property={properties.first_email}
										error={object.first_email_error}
										update={() => this.setState({first_email: !object.first_email})}
										label={'First Email Sent'}
									/>
								</div>

								<div className="col-md-6">
									<Framework.Elements.Checkbox
										value={object.final_email}
										property={properties.final_email}
										error={object.final_email_error}
										update={() => this.setState({final_email: !object.final_email})}
										label={'Final Email Sent'}
									/>
								</div>
							</div>

							<div className="row">
								<div className="col-md-6">
									<Framework.Elements.Checkbox
										value={object.phone}
										property={properties.phone}
										error={object.phone_error}
										update={() => this.setState({phone: !object.phone})}
										label={'Phone Call Made'}
									/>
								</div>

								<div className="col-md-6">
									<Framework.Elements.Checkbox
										value={object.collections}
										property={properties.collections}
										error={object.collections_error}
										update={() => this.setState({collections: !object.collections})}
										label={'Sent to Collections'}
									/>
								</div>
							</div>

						</fieldset>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</div>
			</div>
		);
	};

}
